/** Generic status used by TimeSlots, Donors etc. */
export enum ApiStatus {
  Unknown = 0,
  Draft = 1,
  Active = 2,
  Inactive = 3
}

export const ApiStatusLabel: Record<ApiStatus, string> = {
  [ApiStatus.Unknown]: 'Unknown',
  [ApiStatus.Draft]: 'Draft',
  [ApiStatus.Active]: 'Active',
  [ApiStatus.Inactive]: 'Inactive'
};

/** Status enum for Reward definitions — matches the server Status enum exactly. */
export enum RewardStatus {
  Unknown = 0,
  Draft = 1,
  Active = 2,
  Inactive = 3
}

export const RewardStatusLabel: Record<RewardStatus, string> = {
  [RewardStatus.Unknown]: 'Unknown',
  [RewardStatus.Draft]: 'Draft',
  [RewardStatus.Active]: 'Active',
  [RewardStatus.Inactive]: 'Inactive'
};

export enum DayOfWeek {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6
}

export const DayOfWeekLabel: Record<DayOfWeek, string> = {
  [DayOfWeek.Sunday]: 'Sunday',
  [DayOfWeek.Monday]: 'Monday',
  [DayOfWeek.Tuesday]: 'Tuesday',
  [DayOfWeek.Wednesday]: 'Wednesday',
  [DayOfWeek.Thursday]: 'Thursday',
  [DayOfWeek.Friday]: 'Friday',
  [DayOfWeek.Saturday]: 'Saturday'
};

/** Shared API response wrapper for paginated data. */
export interface PaginatedResult<T> {
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
  items: T[];
}

export interface PaginationParams {
  PageNumber?: number;
  PageSize?: number;
  SortCriteria?: string;
  SearchTerm?: string;
  /** When true the server returns all records without server-side paging. */
  ClientSidePagination?: boolean;
}
